import Text from 'src/components/text/Text';
import useAccountGuardExpansionUrl from './AccountGuardExpansionUrlUpdate';
import './AccountGuardPolicyDisclaimer.scss';

const AccountGuardPolicyDisclaimer = () => {
  const { isAccountGuardExpansionEnabled } = useAccountGuardExpansionUrl();
  return (
    <div className="banner card">
      <div className="material-surface account-guard-policy-disclaimer">
        <blockquote className="">
          <p className="account-guard-policy-disclaimer-text">
            <Text category="AccountGuardV2" id={isAccountGuardExpansionEnabled ? 'Disclaimer1_1' : 'Disclaimer1'} />
          </p>
          <p className="account-guard-policy-disclaimer-text">
            <Text category="AccountGuardV2" id={isAccountGuardExpansionEnabled ? 'Disclaimer2_1' : 'Disclaimer2'} />
          </p>
          <p className="account-guard-policy-disclaimer-text">
            <Text category="AccountGuardV2" id={'Disclaimer3'} />
          </p>
        </blockquote>
      </div>
    </div>
  );
};
export default AccountGuardPolicyDisclaimer;
